import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { Observable } from 'rxjs';
import { Allergen, MedicalCondition, Patient, PatientAdditional, PatientAllergen, Surgery, PatientMedicalCondition, InsertPatientMedicalHistoryConditionModel } from '../models';
import { Api, Session, HistoryApi } from '../services/index';
import { MyModal } from '../components/modal/modal';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { TextBoxComponent, NumericTextBoxComponent } from '@syncfusion/ej2-angular-inputs';

@Component({
	selector: 'app-medical-history',
	templateUrl: './dashboard-medical-history.html',
	styleUrls: ['dashboard-medical-history.css']
})

export class DashboardMedicalHistoryComponent implements OnInit {
	@ViewChild('myModal') public _modalSearchAllergen: MyModal;
	@ViewChild('modalPatientConditions') public _modalPatientSearchConditions: MyModal;
	@ViewChild('modalFamilyConditions') public _modalPatientFamilySearchConditions: MyModal;
	@ViewChild('modalSurgery') public _modalSurgery: MyModal;
	// @ViewChild('modalDialog') public modalDialog: DialogComponent;
	public target: string = "#targetModal";
	public width: string = '95%';
	public height: string = '100%';
	public header: string = 'Search Allergies';
	// Initialize Button to open the modal Dialog
	// public buttons: Object[] = [{ click: this.dlgButtonClick, buttonModel: { content: 'Close', cssClass: 'e-flat', isPrimary: true } }];
	public isModal: Boolean = true;
	public animationSettings: Object = { effect: 'None' };
	public hide: any;
	position: object = { X: 'top', Y: 'center' };
	public dialogdragging: Boolean = true;
	public showCloseIcon: Boolean = true;
	public dialogResize: Boolean = true;


	allergenSearch: string = '';
	foundAllergens: Allergen[] = [];
	foundMedicalConditions: PatientMedicalCondition[] = [];
	foundSurgeries: Surgery[] = [];

	familyMedicalConditions: PatientMedicalCondition[] = [];
	medicalConditionSearch: string = '';
	addMedicalConditionName: string = '';
	addMedicalConditionDescription: string = '';
	patient: Patient;
	patientAdditional: PatientAdditional = new PatientAdditional;
	patientAllergens: Allergen[] = [];
	patientMedicalConditions: PatientMedicalCondition[] = [];
	patientSurgeries: Surgery[] = [];
	surgerySearch: string = '';

	loading = false;
	public isRequesting: boolean;
	constructor(private api: Api,
		private historyApi: HistoryApi,
		private route: ActivatedRoute,
		private router: Router,
		private service: NotificationsService,
		private session: Session) {
	}
//   modalBtnClick() {
   
//       this.modalDialog.show(); 
//     }
  
  
//     public dlgButtonClick: EmitType<Object> = () => {
//       this.allergenSearch = '';
//       this.foundAllergens = null;
//       this.hide();      
//     }
   
//     public dialogClose: EmitType<Object> = () => {
//       this.allergenSearch = '';
//       this.foundAllergens = null;
//       this.modalDialog.visible = false;
//   }
  
   
//     public overlayClick(): void {
//       this.allergenSearch = '';
//       this.foundAllergens = null;
//       this.modalDialog.hide();
  
//     }
	ngOnInit() {
		this.loading = true;
		this.isRequesting = true;

		let getPatient = this.api.getMember(this.session.patientId).subscribe(patient => {
			this.patient = patient;



			let _getPatientAllergens = this.api.getPatientAllergens(this.session.patientId).map(res => {
				this.patientAllergens = res;
			});
			let _getPatientMedicalConditions = this.historyApi.getMedicalCondition(this.session.patientId, '1').map(res => {
				this.patientMedicalConditions = res;
			});
			let _getPatientSurgeries = this.api.getPatientSurgeries(this.session.patientId).map(res => {
				this.patientSurgeries = res;
			});
			let _getPatientFamilyMedicalConditions = this.historyApi.getMedicalCondition(this.session.patientId, '2').map(res => {
				this.familyMedicalConditions = res;
			});
			let _getPatientHistoryAdditional = this.api.getPatientHistoryAdditional(this.session.patientId).map(res => {
				if (res) {
					this.patientAdditional = res;
				} else {
					this.patientAdditional.currentSmoker = false;
					this.patientAdditional.alcoholConsumptionType = false;
				}
			});

			Observable.forkJoin([_getPatientAllergens,
				_getPatientMedicalConditions,
				_getPatientSurgeries,
				_getPatientFamilyMedicalConditions,
				_getPatientHistoryAdditional
			]).subscribe(results => {
				this.loading = false;
				this.isRequesting = false;
			}, err => {
				this.loading = false;
				this.isRequesting = false;
			});



		});








	}

	getAllergens() {
		this.api.getPatientAllergens(this.session.patientId).subscribe(res => {
			this.patientAllergens = res;
			this.loading = false;
			this.isRequesting = false;
		});
	}

	getPatientMedicalConditions() {
		this.historyApi.getMedicalCondition(this.session.patientId, '1').subscribe(res => {
			this.patientMedicalConditions = res;
		});
	}

	getPatientSurgeries() {
		this.api.getPatientSurgeries(this.session.patientId).subscribe(res => {
			this.patientSurgeries = res;
		});
	}

	getFamilytMedicalConditions() {
		this.historyApi.getMedicalCondition(this.session.patientId, '2').subscribe(res => {
			this.familyMedicalConditions = res;
		});
	}

	getPatientHistoryAdditional() {

	}

	removeAllergen(allergen: Allergen) {
		this.loading = true;
		this.isRequesting = true;
		let result = this.api.deletePatientAllergy(this.session.patientId, allergen.id);
		result.subscribe(response => {
			this.getAllergens();
			this.loading = false;
			this.isRequesting = false;
		}, (error) => {
			this.service.error('Error while removing allergen', 'There was an error while saving, contact MeMD Team');
			this.loading = false;
			this.isRequesting = false;
		})
	}
	openAllergySearch() {
		this._modalSearchAllergen.open();
	}
	closeAllergySearch() {
		this.allergenSearch = '';
		this.foundAllergens = [];
		this._modalSearchAllergen.close();
	}
	searchAllergens() {
		this.loading = true;
		this.isRequesting = true;
		this.foundAllergens = [];
		let result = this.api.searchAllergens(this.allergenSearch);
		result.subscribe(response => {
			this.loading = false;
			this.isRequesting = false;
			let userSelectedAllergy = new Allergen();
			userSelectedAllergy.allergenTypeDescription = 'Not Specified';
			userSelectedAllergy.code = 'NS';
			userSelectedAllergy.description = this.allergenSearch;
			userSelectedAllergy.id = 0;
			userSelectedAllergy.allergenTypeId = 3;
			userSelectedAllergy.dateCreated = new Date();
			if (response.length === 0) {

				this.foundAllergens.push(userSelectedAllergy);
			} else {
				this.foundAllergens = response;
				this.foundAllergens.push(userSelectedAllergy);
			}


		}, (error) => {
			let userSelectedAllergy = new Allergen();
			userSelectedAllergy.allergenTypeDescription = 'Not Specified';
			userSelectedAllergy.code = 'NS';
			userSelectedAllergy.description = this.allergenSearch;
			userSelectedAllergy.id = 0;
			userSelectedAllergy.allergenTypeId = 3;
			userSelectedAllergy.dateCreated = new Date();
			this.foundAllergens.push(userSelectedAllergy);
			//this.service.error('Error while searching', 'There was an error while saving, contact MeMD Team');
			this.loading = false;
			this.isRequesting = false;
		})
	}
	addAllergen(allergen: Allergen) {
		this.loading = true;
		this.isRequesting = true;

		this.foundAllergens = [];
		this.allergenSearch = '';
		let patientAllergen: PatientAllergen = new PatientAllergen;
		patientAllergen.allergenId = allergen.id;
		patientAllergen.identificationDate = allergen.dateCreated;
		patientAllergen.reaction = allergen.allergenTypeDescription;
		patientAllergen.description = allergen.description;
		let result = this.api.updatePatientAllergy(this.session.patientId, patientAllergen);
		result.subscribe(response => {
			this._modalSearchAllergen.close();
			this.getAllergens();
		}, (error) => {
			this.service.error('Error while adding allergen', 'There was an error while saving, contact MeMD Team');
			this.loading = false;
			this.isRequesting = false;
			this._modalSearchAllergen.close();
		})
	}


	openPatientConditionsSearch() {
		this._modalPatientSearchConditions.open();
	}
	closePatientConditionsSearch() {
		this._modalPatientSearchConditions.close();
	}
	openPatientFamilyConditionsSearch() {
		this._modalPatientFamilySearchConditions.open();
	}
	closePatientFamilyConditionsSearch() {
		this._modalPatientFamilySearchConditions.close();
	}
	openPatientSurgerySearch() {
		this.surgerySearch = '';
		this.foundSurgeries = [];
		this._modalSurgery.open();
	}
	closePatientSurgerySearch() {
		this._modalSurgery.close();
	}
	removeCondition(conditionId: number, type: number) {
		this.loading = true;
		this.isRequesting = true;
		this.api.deletePatientMedicalConditions(this.session.patientId, conditionId).subscribe(res => {
			if (type === 1) {
				this.patientMedicalConditions = res;
			} else if (type === 2) {
				this.familyMedicalConditions = res;
			}

			this.loading = false;
			this.isRequesting = false;

		}, (error) => {
			this.loading = false;
			this.isRequesting = false;
		})

	}

	addCondition(type: number) {
		this.loading = true;
		this.isRequesting = true;
		let newMedicalCondition = new MedicalCondition();
		if (type === 1) {
			newMedicalCondition.conditionTypeId = 1;
			newMedicalCondition.createdById = Number(this.session.patientId);
			newMedicalCondition.description = this.addMedicalConditionDescription;
			newMedicalCondition.name = this.addMedicalConditionName;
		} else if (type === 2) {
			newMedicalCondition.conditionTypeId = 2;
			newMedicalCondition.createdById = Number(this.session.patientId);
			newMedicalCondition.description = this.addMedicalConditionDescription;
			newMedicalCondition.name = this.addMedicalConditionName;
		}
		this.api.insertPatientMedicalConditions(this.session.patientId, newMedicalCondition).subscribe(res => {
			this.addMedicalConditionDescription = '';
			this.addMedicalConditionName = '';
			this.loading = false;
			this.isRequesting = false;
			if (type === 1) {
				this.patientMedicalConditions = res;
				this.closePatientConditionsSearch()
			} else if (type === 2) {
				this.familyMedicalConditions = res;
				this.closePatientFamilyConditionsSearch();
			}

		}, (error) => {
			this.loading = false;
			this.isRequesting = false;
		}, () => {

		})

	}

	removeSurgery(surgery: Surgery) {
		this.loading = true;
		this.isRequesting = true;
		let result = this.api.deletePatientSurgery(this.session.patientId, surgery.surgeryId);
		result.subscribe(response => {
			this.getPatientSurgeries();
			this.loading = false;
			this.isRequesting = false;
		}, (error) => {
			this.service.error('Error while removing allergen', 'There was an error while saving, contact MeMD Team');
			this.loading = false;
			this.isRequesting = false;
		})
	}
	searchSurgery() {
		this.loading = true;
		this.isRequesting = true;
		let result = this.api.searchSurgeries(this.surgerySearch);
		result.subscribe(response => {
			this.foundSurgeries = response;
			if (this.foundSurgeries.length === 0) {
				let userSurgery = new Surgery();
				userSurgery.description = this.surgerySearch;
				this.foundSurgeries.push(userSurgery);
			}
			this.loading = false;
			this.isRequesting = false;
		}, (error) => {
			this.service.error('Error while searching', 'There was an error while saving, contact MeMD Team');
			this.loading = false;
			this.isRequesting = false;
		})
	}
	addSurgery(surgery: Surgery) {
		this.loading = true;
		this.isRequesting = true;
		let result = this.api.insertPatientSurgery(this.session.patientId, surgery);
		result.subscribe(response => {
			this.getPatientSurgeries();
			this.loading = false;
			this.isRequesting = false;
			this.surgerySearch = '';
			this.foundSurgeries = [];
			this._modalSurgery.close();
		}, (error) => {
			this.foundSurgeries = [];
			this.service.error('Error while adding surgery.', 'There was an error while saving, contact MeMD Team');
			this.loading = false;
			this.isRequesting = false;
			this.surgerySearch = '';
			this._modalSurgery.close();
		})
	}

	saveAdditional() {
		let result = this.api.updatePatientAdditional(this.session.patientId, this.patientAdditional);
		result.subscribe(response => {
			this.patientAdditional = response;
			this.router.navigate(['/dashboard']);
			this.service.success('Save Successful');
		}, (error) => {
			this.service.error('Patient Save Failed', 'There was an error while saving, contact MeMD Team');
		})
	}

	cancel() {
		this.router.navigate(['/dashboard']);
	}

	gotoDashboard() {
		this.cancel();
	}

	cleanSmokingYears(e) {
		if (e.target.value.match(/[^0-9]/g)) {
			document.getElementById('smokingalertmessage').style.display = 'block';
		} else {
			document.getElementById('smokingalertmessage').style.display = 'none';
		}
	}
}
